

















































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { exportInfor } from '@/api/index'
import { getTitleList,getSmallProgramList } from '@/api/competition'
@Component({
  name: 'TitleIndex',
})
export default class extends Vue {
  @Prop() private flag!: any
  @Prop() private tateData!: any
  @Prop() private turnoverData!: any

  private titleId = ''
  private options =  []
  private smallProgramId = ''
  private smallProgram = []

  nowIndex = 2 - 1
  value = []
  tabsParam = ['昨日', '近7日', '近30日', '本周', '本月']
  @Watch('flag')
  getNowIndex(val) {
    this.nowIndex = val
  }
  // tab切换
  toggleTabs(index: number) {
    this.nowIndex = index
    this.value = []
    this.$emit('sendTitleInd', index + 1)
  }

  created() {
    this.init(Number(this.$route.query.status) || 0)
  }

  private async init(activeIndex: number = 0, isSearch?) {
    if (this.options.length === 0){
      const pageParams = {
        page: this.page,
        pageSize: this.pageSize,
        type: 0,
      }
      await getTitleList(pageParams)
        .then((res: any) => {
          if (String(res.data.code) === '1') {
            this.options = res.data && res.data.data && res.data.data.records
            // this.titleId = res.data.data.records[0].id
            // this.counts = res.data.data.total
          }
          // if (!res.data.data.records.length && type === 'search') {
          //   this.$message.error('未搜索到相关员工，请核对员工姓名是否正确')
          // }
        })
        .catch((err) => {
          this.$message.error('请求出错了：' + err.message)
        })
      }
      if (this.smallProgram.length === 0){
      const pagesParams = {
        page: this.page,
        pageSize: this.pageSize,
        type: 0,
      }
    await getSmallProgramList(pagesParams)
      .then((res: any) => {
        if (String(res.data.code) === '1') {
          this.smallProgram = res.data && res.data.data && res.data.data.records
          // this.titleId = res.data.data.records[0].id
          // this.counts = res.data.data.total
        }
      })
      .catch((err) => {
        this.$message.error('请求出错了：' + err.message)
      })
    }
  }

  // 监听 titleId 的变化
  private handleTitleChange() {
    // this.init();
    this.$emit('sendTitleIndId', this.titleId, this.smallProgramId)
  }

  //  数据导出
  /** 导出按钮操作 */
  handleExport() {
    this.$confirm('是否确认导出最近30天运营数据?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(async function () {
        const { data } = await exportInfor()
        let url = window.URL.createObjectURL(data)
        var a = document.createElement('a')
        document.body.appendChild(a)
        a.href = url
        a.download = '运营数据统计报表.xlsx'
        a.click()
        window.URL.revokeObjectURL(url)
      })
      .then((response) => {})
  }
}
